import api from "services/candidates";

const state = {
  all: [],
  selected: {},
  filter: "all",
  pagination: [],
  totalPages: "",
  currentPage: "",
  searchQuery: {
    search: "",
    postcode: "",
    applicationBegin: "",
    applicationEnd: "",
    registrationBegin: "",
    registrationEnd: "",
    registeredBegin: "",
    registeredEnd: "",
    feesBegin: "",
    feesEnd: "",
    registrationStubMonth: null,
    registrationStubYear: null,
    schools: "",
    campuses: "",
    type: "",
    grade: "",
    year: "",
    process: "",
    fileStatus: null,
    status: null,
    funding: null,
    staffs: null,
    trainings: null,
    training_options: null,
    events: null,
    involvedEvents: null,
    duplicates: false,
    finances: false,
    file_list: "",
    file_from: "",
    file_to: ""
  },
  selectedFilters: {
    applicationBegin: null,
    applicationEnd: null,
    registrationBegin: null,
    registrationEnd: null,
    registeredBegin: null,
    registeredEnd: null,
    feesBegin: null,
    feesEnd: null,
    registrationStubMonth: null,
    registrationStubYear: null,
    fileStatus: null,
    status: null,
    funding: null,
    process: null,
    type: null,
    grade: null,
    year: null,
    staffs: null,
    schools: null,
    campuses: null,
    trainings: null,
    training_options: null,
    events: null,
    involvedEvents: null,
    file_list: null,
    file_from: null,
    file_to: null
  },
  status: null
};

const getters = {
  getAllUsers: state => state.all,
  getAllUserCount: state => state.all.length,
  getSelectedUser: state => state.selected,
  getSearchQuery: state => state.searchQuery,
  getSelectedFilters: state => state.selectedFilters,
  getStatus: state => state.status,
  totalPages(state) {
    return state.pagination.total_pages;
  },
  currentPage(state) {
    return state.pagination.current_page;
  },
  pagination(state) {
    return state.pagination;
  }
};

const mutations = {
  setUsers: (state, payload) => {
    state.all = payload.users;
    state.pagination = payload.meta.pagination;
    const { total, limit, skip } = state.pagination;
    state.totalPages = Math.ceil(total / limit);
    state.currentPage = Math.ceil((skip - 1) / limit) + 1;
  },
  toggleActive: (state, payload) => {
    const user = state.all.find(user => {
      return user.id === payload.id;
    });
    state.all.splice(state.all.indexOf(user), 1, payload);
  },
  selectUser: (state, payload) => {
    state.selected = payload;
  },

  deleteUser: (state, payload) => {
    const user = state.all.find(user => {});
    state.all.splice(state.all.indexOf(user), 1);
  },
  resetSearch: state => {
    state.selectedFilters = {
      applicationBegin: null,
      applicationEnd: null,
      feesBegin: null,
      feesEnd: null,
      registrationStubMonth: null,
      registrationStubYear: null,
      registrationBegin: null,
      registrationEnd: null,
      registeredBegin: null,
      registeredEnd: null,
      fileStatus: null,
      status: null,
      funding: null,
      process: null,
      type: null,
      grade: null,
      year: null,
      staffs: null,
      schools: null,
      campuses: null,
      trainings: null,
      training_options: null,
      events: null,
      involvedEvents: null,
      file_list: null,
      file_from: null,
      file_to: null
    };

    state.searchQuery = {
      search: "",
      postcode: "",
      applicationBegin: "",
      applicationEnd: "",
      registrationBegin: "",
      registrationEnd: "",
      registeredBegin: "",
      registeredEnd: "",
      feesBegin: "",
      feesEnd: "",
      registrationStubMonth: null,
      registrationStubYear: null,
      schools: "",
      campuses: "",
      type: "",
      grade: "",
      year: "",
      process: "",
      fileStatus: null,
      status: null,
      funding: null,
      staffs: null,
      trainings: null,
      training_options: null,
      events: null,
      involvedEvents: null,
      duplicates: false,
      finances: false,
      file_list: "",
      file_from: "",
      file_to: ""
    };
  },
  setStatus: (state, payload) => {
    state.status = payload.status;
  }
};

const actions = {
  async setUsers({ commit }, query) {
    const payload = await api.search(query);
    if ((await payload.status) === 200) {
      commit("setUsers", await payload.data);
    }
    commit("setStatus", await payload);
  },
  async setFinancesUsers({ commit }, query) {
    const payload = await api.finances(query);
    if ((await payload.status) === 200) {
      commit("setUsers", await payload.data);
    }
    commit("setStatus", await payload);
  },
  async selectUser({ commit }, id) {
    const payload = (await api.showUser(id)).data;
    commit("selectUser", await payload);
  },
  async deleteUser({ commit }, id) {
    const payload = (await api.deleteUser(id)).data;
    commit("deleteUser", await payload.user);
  },
  async updateUser({ commit, state }, query) {
    const payload = (await api.updateUser(state.selected.id, query)).data;
    commit("updateUser", await payload);
  },
  resetSearch({ commit }) {
    commit("resetSearch");
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
